module.exports = __webpack_public_path__ + "img/after-round.bb59c7aa.png";